/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import overlayMixin from "../mixins/overlay-mixin";

export default baustein.register("editing-overlay", {
    mixins: [overlayMixin],

    defaultOptions: {
        overlaySize: "large",
        contentEditUrl: undefined
    },

    /**
     * Submit event handler
     * @param {object} event The event object
     */
    onOverlayCloseIntent() {
        this.close();
    },

    /**
     * Get the overlay content
     */
    getOverlayContent() {
        return Promise.resolve(`
            <iframe
                sandbox="allow-same-origin allow-scripts allow-forms"
                width="100%" height="450px"
                src="${this.options.contentEditUrl}"
            ></iframe>
        `);
    }
});

